<div class="wb-expanded-search-wrapper">
    @if(!activeSearch) {
    <mat-form-field appearance="outline" class="template-select-wrapper">
        <mat-select placeholder="Search by" [value]="searchByOption" (selectionChange)="onSearchByChange($event)">
            <mat-option value="PM">PM</mat-option>
            <mat-option value="NN">Notification #</mat-option>
            <mat-option value="PJ">Penta Job</mat-option>
        </mat-select>
    </mat-form-field>

    <div class="search-multiple-dialog-wrapper">
        @if(searchByOption === 'PM') {
        <div class="search-multiple-content">
            <h4>Add PM# separated by commas</h4>
            <textarea (input)="searchInput = $event.target.value" [value]="searchInput"  placeholder="Add multiple PM#"></textarea>
        </div>
        }
        @else if(searchByOption === 'NN') {
        <div class="search-multiple-content">
            <h4>Add Notification # separated by commas</h4>
            <textarea (input)="searchInput = $event.target.value" [value]="searchInput" placeholder="Add multiple Notification #"></textarea>
        </div>
        }
        @else if(searchByOption === 'PJ') {
        <div class="search-multiple-content">
            <h4>Add Penta Job separated by commas</h4>
            <textarea (input)="searchInput = $event.target.value" [value]="searchInput" placeholder="Add multiple Penta Jobs"></textarea>
        </div>
        }

        <div class="select-week-wrapper">
            <mat-form-field appearance="outline" class="full-width">
                <mat-label>Select Date Range</mat-label>
                <mat-date-range-input [rangePicker]="picker">
                    <input matStartDate placeholder="Start date" [(ngModel)]="startDateRange">
                    <input matEndDate placeholder="End date" [(ngModel)]="endDateRange">
                </mat-date-range-input>
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-date-range-picker #picker></mat-date-range-picker>
            </mat-form-field>
        </div>
    </div>
    }
    @if(activeSearch) {
        <mat-spinner [diameter]="50"></mat-spinner>
        Searching ...
    }
    <div class="dialog-actions">
        <button mat-raised-button color="warn" (click)="close()">Cancel</button>
        @if(!activeSearch) {
        <button mat-raised-button color="primary" (click)="search()">Search</button>
        }
    </div>
    
</div>
